import ActionsField from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/ActionsField/ActionsField.jsx';
import EditableCurrencyField from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/CurrencyFieldEditable/CurrencyFieldEditable.jsx';
import DateValueField from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/DateValueField/DateValueField.jsx';
import DaySelectField from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/DaySelectField/index.js';
import GoalField from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/GoalField/GoalField.jsx';
import NameField from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/NameField/NameField.jsx';
import NumberFieldEditable from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/NumberFieldEditable/NumberFieldEditable.jsx';
import PercentFieldEditable from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/PercentFieldEditable/PercentFieldEditable.jsx';
import CurrencyField from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/ReadOnlyFields/CurrencyField.jsx';
import NumberField from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/ReadOnlyFields/NumberField.jsx';
import OrderIdField from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/ReadOnlyFields/OrderIdField.jsx';
import OrderStatusField from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/ReadOnlyFields/OrderStatusField.jsx';
import PercentField from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/ReadOnlyFields/PercentField.jsx';
import PredictiveBudgetField from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/ReadOnlyFields/PredictiveBudgetField.jsx';
import SelectTextValue from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/SelectTextValue/SelectTextValue.jsx';
import TextValueField from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/TextValueField.jsx';
import TimeField from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/TimeField/TimeField.jsx';
import { DECIMAL_LIMIT } from './campaignBuilder.js';
import { Columns } from './myCampaigns.js';

export const builderColumnsObjects = {
  [Columns.EXPANDER]: {
    id: Columns.EXPANDER,
    viewType: 'builder_schema',
    Header: '',
    accessor: 'name',
    Cell: NameField,
    width: 360,
    isDragDisabled: true,
    fixedCell: true,
  },
  [Columns.MASK]: {
    id: Columns.MASK,
    Header: '',
    accessor: Columns.MASK,
    width: '100%',
    disableResizing: true,
    isDragDisabled: true,
    fixedCell: true,
  },
  [Columns.ACTIONS_MENU]: {
    id: Columns.ACTIONS_MENU,
    Header: '',
    accessor: Columns.ACTIONS_MENU,
    Cell: ActionsField,
    disableResizing: true,
    isDragDisabled: true,
    hideColumnForNonFinancialUser: true,
    fixedCell: true,
  },
  [Columns.VAT]: {
    id: Columns.VAT,
    accessor: Columns.VAT,
    Cell: EditableCurrencyField,
    onlyTileEditable: true,
    isCurrency: true,
    decimals: DECIMAL_LIMIT.BUDGET,
  },
  [Columns.CHANNEL_MIX_BUDGET]: {
    accessor: 'channelMixBudget',
    id: 'channelMixBudget',
    Cell: CurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    hideColumnForNonFinancialUser: true,
    isCurrency: true,
    hideCurrencyForEmptyValue: true,
  },
  dateFrom: {
    id: 'dateFrom',
    Header: 'Start date',
    accessor: 'dateFrom',
    Cell: DateValueField,
  },
  dateTo: {
    id: 'dateTo',
    Header: 'End date',
    accessor: 'dateTo',
    Cell: DateValueField,
  },
  objective: {
    id: 'objective',
    Header: 'Objective',
    accessor: 'objective',
    Cell: SelectTextValue,
    onlyTileEditable: true,
  },
  partner: {
    id: 'partner',
    accessor: 'partner',
    Cell: SelectTextValue,
    onlyTileEditable: true,
  },
  rowObjective: {
    id: 'rowObjective',
    accessor: 'rowObjective',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  funnelStrategy: {
    accessor: 'funnelStrategy',
    id: 'funnelStrategy',
    Cell: SelectTextValue,
    onlyTileEditable: true,
  },
  pricingType: {
    accessor: 'pricingType',
    id: 'pricingType',
    Cell: SelectTextValue,
    hideColumnForNonFinancialUser: true,
    onlyTileEditable: true,
  },
  typeOfBuying: {
    accessor: 'typeOfBuying',
    id: 'typeOfBuying',
    Cell: SelectTextValue,
    onlyTileEditable: true,
  },
  network: {
    accessor: 'network',
    id: 'network',
    Cell: SelectTextValue,
    onlyTileEditable: true,
  },
  format: {
    accessor: 'format',
    id: 'format',
    Cell: SelectTextValue,
    onlyTileEditable: true,
  },
  ctr: {
    id: 'ctr',
    accessor: 'ctr',
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
    onlyTileEditable: true,
  },
  pricingValue: {
    id: 'pricingValue',
    accessor: 'pricingValue',
    Cell: EditableCurrencyField,
    decimals: DECIMAL_LIMIT.PRICE_VALUE,
    isCurrency: true,
    onlyTileEditable: true,
    hideCurrencyForEmptyValue: true,
    hideColumnForNonFinancialUser: true,
  },
  vtr: {
    id: 'vtr',
    accessor: 'vtr',
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
    onlyTileEditable: true,
  },
  cr: {
    id: 'cr',
    accessor: 'cr',
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
    onlyTileEditable: true,
  },
  cpc: {
    accessor: 'cpc',
    id: 'cpc',
    Cell: EditableCurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCurrency: true,
    onlyTileEditable: true,
    hideCurrencyForEmptyValue: true,
    hideColumnForNonFinancialUser: true,
  },
  impression: {
    accessor: 'impression',
    id: 'impression',
    Cell: NumberFieldEditable,
    onlyTileEditable: true,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  cpm: {
    accessor: 'cpm',
    id: 'cpm',
    Cell: EditableCurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCurrency: true,
    onlyTileEditable: true,
    hideCurrencyForEmptyValue: true,
    hideColumnForNonFinancialUser: true,
  },
  clicks: {
    accessor: 'clicks',
    id: 'clicks',
    Cell: NumberFieldEditable,
    onlyTileEditable: true,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  videoViews: {
    accessor: 'videoViews',
    id: 'videoViews',
    Cell: NumberFieldEditable,
    onlyTileEditable: true,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  cpa: {
    accessor: 'cpa',
    id: 'cpa',
    Cell: EditableCurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCurrency: true,
    onlyTileEditable: true,
    hideCurrencyForEmptyValue: true,
    hideColumnForNonFinancialUser: true,
  },
  leadRate: {
    Header: 'Lead Rate',
    id: 'leadRate',
    accessor: 'leadRate',
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    isCalculated: true,
    isPercentField: true,
    onlyTileEditable: true,
  },
  cpv: {
    accessor: 'cpv',
    id: 'cpv',
    Cell: EditableCurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCurrency: true,
    onlyTileEditable: true,
    hideCurrencyForEmptyValue: true,
    hideColumnForNonFinancialUser: true,
  },
  dspCost: {
    accessor: 'dspCost',
    id: 'dspCost',
    Cell: EditableCurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCurrency: true,
    onlyTileEditable: true,
    hideColumnForNonFinancialUser: true,
  },
  otherTechCost: {
    Cell: EditableCurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCurrency: true,
    onlyTileEditable: true,
    hideColumnForNonFinancialUser: true,
    hideForNonIntegratedUser: true,
  },
  [Columns.ADSERVER_COST]: {
    accessor: Columns.ADSERVER_COST,
    id: Columns.ADSERVER_COST,
    Cell: EditableCurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCurrency: true,
    onlyTileEditable: true,
    hideColumnForNonFinancialUser: true,
  },
  [Columns.BUDGET]: {
    accessor: Columns.BUDGET,
    id: Columns.BUDGET,
    Cell: EditableCurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCurrency: true,
    onlyTileEditable: true,
    hideColumnForNonFinancialUser: true,
  },
  [Columns.OPTIMAL_BUDGET]: {
    Header: 'Optimal budget',
    id: Columns.OPTIMAL_BUDGET,
    accessor: Columns.OPTIMAL_BUDGET,
    Cell: PredictiveBudgetField,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCurrency: true,
    isPredictiveColumn: true,
  },
  [Columns.COST_PER_METRIC]: {
    Header: 'Expected CPA',
    id: Columns.COST_PER_METRIC,
    accessor: Columns.COST_PER_METRIC,
    Cell: PredictiveBudgetField,
    decimals: DECIMAL_LIMIT.PREDICTIVE_BUDGET,
    isCurrency: true,
    hideColumnForNonFinancialUser: true,
    isPredictiveColumn: true,
  },
  plannedBudget: {
    Header: 'Planned budget',
    accessor: 'plannedBudget',
    id: 'plannedBudget',
    Cell: CurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    hideColumnForNonFinancialUser: true,
    isCurrency: true,
    hideCurrencyForEmptyValue: true,
  },
  [Columns.EXPECTED_CPC]: {
    Header: 'Expected CPC',
  },
  [Columns.VIEWS]: {
    Header: 'Expected CPV',
  },
  [Columns.EXPECTED_CPM]: {
    Header: 'Expected CPM',
  },
  compoundBudget: {
    accessor: 'compoundBudget',
    id: 'compoundBudget',
    Cell: CurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCurrency: true,
    hideColumnForNonFinancialUser: true,
  },
  creative: {
    accessor: 'creative',
    id: 'creative',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  buying: {
    accessor: 'buying',
    id: 'buying',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  activity: {
    accessor: 'activity',
    id: 'activity',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  site: {
    accessor: 'site',
    id: 'site',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  brand: {
    Header: 'brand',
    accessor: 'brand',
    id: 'brand',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  product: {
    Header: 'product',
    accessor: 'product',
    id: 'product',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  series: {
    Header: 'series',
    accessor: 'series',
    id: 'series',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  model: {
    Header: 'model',
    accessor: 'model',
    id: 'model',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  language: {
    accessor: 'language',
    id: 'language',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  targetingType: {
    accessor: 'targetingType',
    id: 'targetingType',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  iabFormat: {
    accessor: 'iabFormat',
    id: 'iabFormat',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  size: {
    accessor: 'size',
    id: 'size',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  adServingMethod: {
    accessor: 'adServingMethod',
    id: 'adServingMethod',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  targeting: {
    accessor: 'targeting',
    id: 'targeting',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  calculatedClicks: {
    Header: 'Clicks*',
    accessor: 'calculatedClicks',
    id: 'calculatedClicks',
    Cell: NumberField,
    isCalculated: true,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  calculatedImpressions: {
    Header: 'Impressions*',
    accessor: 'calculatedImpressions',
    id: 'calculatedImpressions',
    Cell: NumberField,
    isCalculated: true,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  calculatedLeads: {
    Header: 'Leads*',
    accessor: 'calculatedLeads',
    id: 'calculatedLeads',
    Cell: NumberField,
    isCalculated: true,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  calculatedConversions: {
    Header: 'Conversion*',
    accessor: 'calculatedConversions',
    id: 'calculatedConversions',
    Cell: NumberField,
    isCalculated: true,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  calculatedVideoViews: {
    Header: 'Video 100% complete*',
    accessor: 'calculatedVideoViews',
    id: 'calculatedVideoViews',
    Cell: NumberField,
    isCalculated: true,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  calculatedEcpm: {
    Header: 'ECPM*',
    accessor: 'calculatedEcpm',
    id: 'calculatedEcpm',
    Cell: CurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCalculated: true,
    isCurrency: true,
    hideCurrencyForEmptyValue: true,
    hideColumnForNonFinancialUser: true,
  },
  [Columns.CALCULATED_ECPV]: {
    accessor: Columns.CALCULATED_ECPV,
    id: Columns.CALCULATED_ECPV,
    Cell: CurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCalculated: true,
    isCurrency: true,
    hideCurrencyForEmptyValue: true,
    hideColumnForNonFinancialUser: true,
  },
  calculatedEcpa: {
    Header: 'Ecpa*',
    accessor: 'calculatedEcpa',
    id: 'calculatedEcpa',
    Cell: CurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCalculated: true,
    isCurrency: true,
    hideCurrencyForEmptyValue: true,
    hideColumnForNonFinancialUser: true,
  },
  calculatedEcpc: {
    Header: 'Ecpc*',
    accessor: 'calculatedEcpc',
    id: 'calculatedEcpc',
    Cell: CurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCalculated: true,
    isCurrency: true,
    hideCurrencyForEmptyValue: true,
    hideColumnForNonFinancialUser: true,
  },
  time: {
    Header: 'Time',
    accessor: 'time',
    id: 'time',
    Cell: TimeField,
    isTimeRange: false,
    onlyTileEditable: true,
  },
  timeRange: {
    Header: 'timeRange',
    accessor: 'timeRange',
    id: 'timeRange',
    Cell: TimeField,
    isTimeRange: true,
    onlyTileEditable: true,
  },
  itemGoal: {
    accessor: 'itemGoal',
    id: 'itemGoal',
    Cell: GoalField,
    hideColumnForNonFinancialUser: true,
  },
  offer: {
    accessor: 'offer',
    id: 'offer',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  campaignType: {
    accessor: 'campaignType',
    id: 'campaignType',
    Cell: TextValueField,
    onlyTileEditable: true,
  },
  activeDays: {
    accessor: 'activeDays',
    id: 'activeDays',
    Cell: DaySelectField,
    onlyTileEditable: true,
  },
  ots: {
    accessor: 'ots',
    id: 'ots',
    Cell: NumberFieldEditable,
    decimals: DECIMAL_LIMIT.INTEGER,
    onlyTileEditable: true,
  },
  reach: {
    accessor: 'reach',
    id: 'reach',
    Cell: NumberFieldEditable,
    decimals: DECIMAL_LIMIT.INTEGER,
    onlyTileEditable: true,
  },
  visitors: {
    accessor: 'visitors',
    id: 'visitors',
    Cell: NumberFieldEditable,
    decimals: DECIMAL_LIMIT.INTEGER,
    onlyTileEditable: true,
  },
  grp: {
    accessor: 'grp',
    id: 'grp',
    Cell: NumberFieldEditable,
    decimals: DECIMAL_LIMIT.INTEGER,
    onlyTileEditable: true,
  },
  cpcl: {
    accessor: 'cpcl',
    id: 'cpcl',
    Cell: EditableCurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCurrency: true,
    onlyTileEditable: true,
  },
  audioCompleteRate25: {
    accessor: 'audioCompleteRate25',
    id: 'audioCompleteRate25',
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    onlyTileEditable: true,
    isPercentField: true,
  },
  audioCompleteRate50: {
    accessor: 'audioCompleteRate50',
    id: 'audioCompleteRate50',
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    onlyTileEditable: true,
    isPercentField: true,
  },
  audioCompleteRate75: {
    accessor: 'audioCompleteRate75',
    id: 'audioCompleteRate75',
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    onlyTileEditable: true,
    isPercentField: true,
  },
  ltr: {
    accessor: 'ltr',
    id: 'ltr',
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    onlyTileEditable: true,
    isPercentField: true,
  },
  otl: {
    accessor: 'otl',
    id: 'otl',
    Cell: SelectTextValue,
    onlyTileEditable: true,
    isCurrency: false,
  },
  mobileOs: {
    accessor: 'mobileOs',
    id: 'mobileOs',
    Cell: SelectTextValue,
    onlyTileEditable: true,
    isCurrency: false,
  },
  calculatedInvestmentShare: {
    accessor: 'calculatedInvestmentShare',
    id: 'calculatedInvestmentShare',
    Cell: PercentField,
    decimals: DECIMAL_LIMIT.PERCENT,
    isCalculated: true,
    isPercentField: true,
  },
  [Columns.CO2]: {
    accessor: Columns.CO2,
    id: Columns.CO2,
    Cell: NumberField,
    hideEmptyValueForReadOnlyRowLevel: true,
    hideColumnForNonFinancialUser: true,
    onlyTileEditable: true,
    decimals: DECIMAL_LIMIT.BUDGET,
  },
  [Columns.CO2_OFFSET]: {
    accessor: Columns.CO2_OFFSET,
    id: Columns.CO2_OFFSET,
    Cell: CurrencyField,
    hideCurrencyForEmptyValue: true,
    hideColumnForNonFinancialUser: true,
    onlyTileEditable: true,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCurrency: true,
  },
  [Columns.IO_ID]: {
    accessor: Columns.IO_ID,
    id: Columns.IO_ID,
    Cell: OrderIdField,
    hideColumnForNonFinancialUser: true,
  },
  [Columns.IO_STATUS]: {
    accessor: Columns.IO_STATUS,
    id: Columns.IO_STATUS,
    Cell: OrderStatusField,
    hideColumnForNonFinancialUser: true,
  },
  [Columns.DEVICE]: {
    id: Columns.DEVICE,
    accessor: Columns.DEVICE,
    Cell: SelectTextValue,
    onlyTileEditable: true,
  },
  [Columns.CALCULATED_SESSIONS]: {
    id: Columns.CALCULATED_SESSIONS,
    accessor: Columns.CALCULATED_SESSIONS,
    Cell: NumberField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  [Columns.CALCULATED_EATP]: {
    id: Columns.CALCULATED_EATP,
    accessor: Columns.CALCULATED_EATP,
    Cell: CurrencyField,
    hideColumnForNonFinancialUser: true,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCurrency: true,
  },
  [Columns.CALCULATED_ECPS]: {
    id: Columns.CALCULATED_ECPS,
    accessor: Columns.CALCULATED_ECPS,
    Cell: CurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    hideColumnForNonFinancialUser: true,
    isCurrency: true,
  },
  [Columns.CALCULATED_ECPA_ANALYTICS]: {
    id: Columns.CALCULATED_ECPA_ANALYTICS,
    accessor: Columns.CALCULATED_ECPA_ANALYTICS,
    Cell: CurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    hideColumnForNonFinancialUser: true,
    isCurrency: true,
  },
  [Columns.CALCULATED_EROI]: {
    id: Columns.CALCULATED_EROI,
    accessor: Columns.CALCULATED_EROI,
    Cell: PercentField,
    decimals: DECIMAL_LIMIT.PERCENT,
  },
  [Columns.REVENUE]: {
    id: Columns.REVENUE,
    accessor: Columns.REVENUE,
    Cell: EditableCurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    hideColumnForNonFinancialUser: true,
    isCurrency: true,
  },
  [Columns.CONNECT_RATE]: {
    id: Columns.CONNECT_RATE,
    accessor: Columns.CONNECT_RATE,
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
  },
  [Columns.CALCULATED_CONVERSIONS_ANALYTICS]: {
    id: Columns.CALCULATED_CONVERSIONS_ANALYTICS,
    accessor: Columns.CALCULATED_CONVERSIONS_ANALYTICS,
    Cell: NumberField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  [Columns.PERCENT_SESSIONS]: {
    id: Columns.PERCENT_SESSIONS,
    accessor: Columns.PERCENT_SESSIONS,
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
  },
  [Columns.TOTAL_CAMPAIGN_REVENUE]: {
    accessor: Columns.TOTAL_CAMPAIGN_REVENUE,
    id: Columns.TOTAL_CAMPAIGN_REVENUE,
    Cell: EditableCurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    isCurrency: true,
    hideColumnForNonFinancialUser: true,
  },
  [Columns.PLATFORM_SHARE]: {
    id: Columns.PLATFORM_SHARE,
    accessor: Columns.PLATFORM_SHARE,
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
  },
  [Columns.CALCULATED_SESSIONS_BY_PERCENT]: {
    id: Columns.CALCULATED_SESSIONS_BY_PERCENT,
    accessor: Columns.CALCULATED_SESSIONS_BY_PERCENT,
    Cell: NumberField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  [Columns.CALCULATED_CONVERSIONS_BY_SESSION]: {
    id: Columns.CALCULATED_CONVERSIONS_BY_SESSION,
    accessor: Columns.CALCULATED_CONVERSIONS_BY_SESSION,
    Cell: NumberField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  [Columns.CALCULATED_REVENUE_BY_PLATFORM_SHARE]: {
    id: Columns.CALCULATED_REVENUE_BY_PLATFORM_SHARE,
    accessor: Columns.CALCULATED_REVENUE_BY_PLATFORM_SHARE,
    Cell: CurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    hideColumnForNonFinancialUser: true,
    isCurrency: true,
  },
  [Columns.PERCENT_NEW_USERS]: {
    id: Columns.PERCENT_NEW_USERS,
    accessor: Columns.PERCENT_NEW_USERS,
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
  },
  [Columns.PERCENT_REGISTRATION]: {
    id: Columns.PERCENT_REGISTRATION,
    accessor: Columns.PERCENT_REGISTRATION,
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
  },
  [Columns.PERCENT_FREE_TRIALS]: {
    id: Columns.PERCENT_FREE_TRIALS,
    accessor: Columns.PERCENT_FREE_TRIALS,
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
  },
  [Columns.PERCENT_FIRST_PAID_SUBSCRIPTIONS_FT]: {
    id: Columns.PERCENT_FIRST_PAID_SUBSCRIPTIONS_FT,
    accessor: Columns.PERCENT_FIRST_PAID_SUBSCRIPTIONS_FT,
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
  },
  [Columns.PERCENT_FIRST_PAID_SUBSCRIPTIONS_EX_FT]: {
    id: Columns.PERCENT_FIRST_PAID_SUBSCRIPTIONS_EX_FT,
    accessor: Columns.PERCENT_FIRST_PAID_SUBSCRIPTIONS_EX_FT,
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
  },
  [Columns.PERCENT_RESUBSCRIPTIONS_FT]: {
    id: Columns.PERCENT_RESUBSCRIPTIONS_FT,
    accessor: Columns.PERCENT_RESUBSCRIPTIONS_FT,
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
  },
  [Columns.PERCENT_RESUBSCRIPTIONS_EX_FT]: {
    id: Columns.PERCENT_RESUBSCRIPTIONS_EX_FT,
    accessor: Columns.PERCENT_RESUBSCRIPTIONS_EX_FT,
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
  },
  [Columns.CALCULATED_NEW_USERS]: {
    id: Columns.CALCULATED_NEW_USERS,
    accessor: Columns.CALCULATED_NEW_USERS,
    Cell: NumberField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  [Columns.CALCULATED_REGISTRATIONS]: {
    id: Columns.CALCULATED_REGISTRATIONS,
    accessor: Columns.CALCULATED_REGISTRATIONS,
    Cell: NumberField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  [Columns.CALCULATED_FREE_TRIALS]: {
    id: Columns.CALCULATED_FREE_TRIALS,
    accessor: Columns.CALCULATED_FREE_TRIALS,
    Cell: NumberField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  [Columns.CALCULATED_FIRST_PAID_SUBSCRIPTIONS_FT]: {
    id: Columns.CALCULATED_FIRST_PAID_SUBSCRIPTIONS_FT,
    accessor: Columns.CALCULATED_FIRST_PAID_SUBSCRIPTIONS_FT,
    Cell: NumberField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  [Columns.CALCULATED_FIRST_PAID_SUBSCRIPTIONS_EX_FT]: {
    id: Columns.CALCULATED_FIRST_PAID_SUBSCRIPTIONS_EX_FT,
    accessor: Columns.CALCULATED_FIRST_PAID_SUBSCRIPTIONS_EX_FT,
    Cell: NumberField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  [Columns.CALCULATED_RESUBSCRIPTIONS_FT]: {
    id: Columns.CALCULATED_RESUBSCRIPTIONS_FT,
    accessor: Columns.CALCULATED_RESUBSCRIPTIONS_FT,
    Cell: NumberField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  [Columns.CALCULATED_RESUBSCRIPTIONS_EX_FT]: {
    id: Columns.CALCULATED_RESUBSCRIPTIONS_EX_FT,
    accessor: Columns.CALCULATED_RESUBSCRIPTIONS_EX_FT,
    Cell: NumberField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  [Columns.CALCULATED_TOTAL_SUBSCRIPTIONS]: {
    id: Columns.CALCULATED_TOTAL_SUBSCRIPTIONS,
    accessor: Columns.CALCULATED_TOTAL_SUBSCRIPTIONS,
    Cell: NumberField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },

  [Columns.PERCENT_AGENCY_COMMISSION]: {
    id: Columns.PERCENT_AGENCY_COMMISSION,
    accessor: Columns.PERCENT_AGENCY_COMMISSION,
    Cell: PercentFieldEditable,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
  },
  [Columns.YOUGOV_FEE]: {
    id: Columns.YOUGOV_FEE,
    accessor: Columns.YOUGOV_FEE,
    Cell: EditableCurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    hideColumnForNonFinancialUser: true,
    isCurrency: true,
  },
  [Columns.CALCULATED_AGENCY_COMMISSION]: {
    id: Columns.CALCULATED_AGENCY_COMMISSION,
    accessor: Columns.CALCULATED_AGENCY_COMMISSION,
    Cell: CurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    hideColumnForNonFinancialUser: true,
    isCurrency: true,
  },
  [Columns.CALCULATED_ASBOF]: {
    id: Columns.CALCULATED_ASBOF,
    accessor: Columns.CALCULATED_ASBOF,
    Cell: CurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    hideColumnForNonFinancialUser: true,
    isCurrency: true,
  },
  [Columns.CALCULATED_CLIENT_COST]: {
    id: Columns.CALCULATED_CLIENT_COST,
    accessor: Columns.CALCULATED_CLIENT_COST,
    Cell: CurrencyField,
    decimals: DECIMAL_LIMIT.BUDGET,
    hideColumnForNonFinancialUser: true,
    isCurrency: true,
  },
};
